/*
 * Альбом — несколько фото, отправленных разом. На сервере это отдельные
 * сообщения с одним номером альбома (albumId): в чате они стоят одним
 * сообщением с сеткой фото (как в приложении и в Telegram).
 */

/** Сколько фото самое большее в одном альбоме. */
export const ALBUM_MAX = 10;
/** Сколько плиток самое большее видно в сообщении; остальные — «+N» на последней. */
export const ALBUM_VISIBLE = 6;
/** Сколько файлов можно приложить к одному сообщению. */
export const MAX_ATTACHMENTS = 10;

export const getAlbumId = (message) => String(message?.albumId || "");

/** Новый номер альбома (тот же вид, что в приложении). */
export const createAlbumId = () => `album-${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;

/** Номер сообщения для фото альбома: номер альбома и место фото в нём. */
export const albumClientId = (albumId, index) => `${albumId}-${String(index).padStart(2, "0")}`;

/**
 * Постоянный номер фото в альбоме: один и тот же, пока фото отправляется и
 * после отправки. По нему же фото стоят в том порядке, в каком их выбрали.
 */
export const albumMemberKey = (message) => String(
    message?.__clientMessageId || message?.clientMessageId || message?._id || ""
);

/** Фото ли это: в альбом идут только фото. */
export const isAlbumPhoto = (file) => {
    const mime = String(file?.type || "").toLowerCase();
    if (mime.startsWith("image/")) return !mime.includes("svg");
    return !mime && /\.(png|jpe?g|gif|webp|bmp|avif|heic|heif)$/i.test(String(file?.name || ""));
};

/** Фото альбома по порядку, в каком их выбрал отправитель. */
export const sortAlbum = (messages) => {
    const albumId = getAlbumId(messages[0]);
    const known = !!albumId && messages.every((message) => albumMemberKey(message).startsWith(`${albumId}-`));
    if (!known) return messages;
    return [...messages].sort((a, b) => {
        const left = albumMemberKey(a);
        const right = albumMemberKey(b);
        return left < right ? -1 : left > right ? 1 : 0;
    });
};

/**
 * Сколько плиток в каждом ряду сетки (сверху вниз) для такого числа фото.
 * 2 → [2], 3 → [1, 2], 4 → [2, 2], 5 → [2, 3], 6 и больше → [3, 3].
 */
export const albumRows = (count) => {
    if (count <= 1) return [1];
    if (count === 2) return [2];
    if (count === 3) return [1, 2];
    if (count === 4) return [2, 2];
    if (count === 5) return [2, 3];
    return [3, 3];
};
